export default __webpack_public_path__ + "static/40-34719144a37b9842a9940213c3720874.jpg";